import { PROGRESS_TRACKER_STEP_APPEARANCES } from '../_sub-comps/progress-tracker-step/models/progress-tracker-step.types';

export const PROGRESS_TRACKER_APPEARANCES = {
  default: PROGRESS_TRACKER_STEP_APPEARANCES.default,
  ticked: PROGRESS_TRACKER_STEP_APPEARANCES.ticked,
} as const;
export type ProgressTrackerAppearance = (typeof PROGRESS_TRACKER_APPEARANCES)[keyof typeof PROGRESS_TRACKER_APPEARANCES];
